<template>
  <div class="page-job">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/hiring`">招工招生</el-breadcrumb-item>
        <el-breadcrumb-item :to="`${$subsitePrefix}/ah/column/job/list`">招聘岗位</el-breadcrumb-item>
        <el-breadcrumb-item>{{ data.JobName }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content job-content">
        <div class="head">
          <div class="left">
            <h3>{{ data.JobName }}</h3>
            <p>
              <strong>{{ job.Salary }}</strong>
              <span>{{ data.Address || "--" }}</span>
              <span>{{ job.Education }}</span>
              <span>{{ job.Experience }}</span>
              <span>招{{ data.RecruitCount }}人</span>
            </p>
          </div>
          <div class="right">
            <div class="btn">
              <a class="chat" href="http://dev.ic.ve-city.com/admin/#/Production/Recruit/Chat">在线沟通</a>
              <a class="send" href="http://dev.ic.ve-city.com/admin/#/production/recruit/recruiters">投递简历</a>
            </div>
            <div class="date">{{ data.CreatedTime }} 发布</div>
          </div>
        </div>
        <div class="body">
          <div class="left">
            <column-header2 :data="{ name: '员工福利' }"></column-header2>
            <!-- <div class="content tags">
              <span v-for="(item, i) in tags" :key="i">{{ item }}</span>
            </div> -->
            <div class="content" v-html="job.Benefits"></div>
            <column-header2 :data="{ name: '职位描述' }"></column-header2>
            <div class="content" v-html="job.JobDescription"></div>
            <column-header2 :data="{ name: '任职要求' }"></column-header2>
            <div class="content" v-html="job.JobRequirements"></div>
            <!-- <column-header2 :data="{ name: '联系方式' }"></column-header2>
            <div class="content" v-html="data.contact"></div> -->
          </div>
          <div class="right">
            <router-link :to="`${$subsitePrefix}/company/home/${job.EnterpriseId}`">
              <div class="img">
                <img @error="imgError" :src="enterprise.LogoLong" :alt="data.Enterprise" />
              </div>
            </router-link>
            <h3>
              <router-link :to="`${$subsitePrefix}/company/home/${job.EnterpriseId}`">{{
                job.Enterprise
              }}</router-link>
            </h3>
            <p>
              <i class="ico-industry"></i>
              {{ enterprise.Industry }}
            </p>
            <p>
              <i class="ico-type"></i>
              {{ enterprise.Nature }}
            </p>
            <p>
              <i class="ico-size"></i>
              {{ enterprise.Scale }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
export default {
  data() {
    return {
      data: {},
      job: {},
      tags: [],
      enterprise: {
        LogoLong: "",
        Industry: "",
        Nature: "",
        Scale: ""
      }
    };
  },
  created() {
    this.init();
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  methods: {
    loadData() {
      getDetail({ name: "RecruitJob", id: this.$route.params.id }).then(res => {
        this.data = res || {};
        if (this.data.Benefits) {
          let listTag = this.data.Benefits.split("，");
          if (listTag.length < 2) {
            listTag = this.data.Benefits.split("、");
          }
          this.tags = listTag;
        }
        if (this.data.JobId) {
          getDetail({ name: "Job", id: this.data.JobId }).then(resE => {
            this.job = resE || {};
            if (resE.EnterpriseId) {
              getDetail({ name: "Enterprise", id: resE.EnterpriseId }).then(
                res3 => {
                  this.Enterprise = res3 || [];
                }
              );
            }
          });
        }
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-job {
  background: #f6f6f9;
  padding-bottom: 40px;
  .job-content {
    padding: 0 0 40px 0;
    .head,
    .body {
      display: flex;
      justify-content: space-between;
    }
    .head {
      padding: 40px 72px;
      border-bottom: 1px solid #eee;
      .left {
        span {
          position: relative;
          padding-left: 10px;
          margin-left: 10px;
          color: #666;
          &::before {
            width: 1px;
            height: 12px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            top: 1px;
            content: ' ';
          }
        }
        strong {
          color: #ff6010;
          font-weight: 500;
          font-size: 20px;
        }
        h3 {
          font-size: 24px;
          font-weight: 500;
          padding-bottom: 12px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .date {
          color: #ccc;
          text-align: center;
          padding-top: 10px;
        }
      }
      .btn {
        a {
          width: 88px;
          height: 32px;
          border-radius: 20px;
          border: 1px solid $primary-color;
          color: $primary-color;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          margin-left: 8px;
          &.send {
            color: #fff;
            background-color: $primary-color;
          }
        }
      }
    }
    .body {
      margin: 0 72px;
      .right {
        width: 212px;
        padding-top: 40px;
        .img {
          width: 212px;
          height: 66px;
          border: 1px solid rgba(238, 238, 238, 1);
          justify-content: center;
          align-items: center;
          display: flex;
        }
        h3 {
          font-weight: 500;
          padding: 20px 0 15px 0;
          font-size: 15px;
        }
        p {
          color: #999;
          line-height: 16px;
          height: 16px;
          padding-bottom: 16px;
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url(~assets/img/feature/intro/ico-industry.png)
              no-repeat left center;
            margin-right: 5px;
          }
          .ico-size {
            background-image: url(~assets/img/feature/intro/ico-size.png);
          }
          .ico-type {
            background-image: url(~assets/img/feature/intro/ico-type.png);
          }
        }
      }
      .left {
        flex: 1;
      }
    }
    .tags {
      color: #999;
      font-size: 12px;
      span {
        background: rgba(252, 252, 252, 1);
        border-radius: 4px;
        border: 1px solid rgba(221, 221, 221, 1);
        padding: 2px 4px;
        margin-right: 8px;
      }
    }
    .content {
      font-size: 14px;
      line-height: 28px;
      color: #666;
      padding-bottom: 20px;
    }
    ::v-deep .comp-column-header {
      padding-top: 24px;
    }
  }
}
</style>
